// ************************************************************************************************
// pathname: /v1/my-jobs/{jobSlug}/suspend
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/** Hook props */
type UseSwrSuspendJobReqBody = ApiRequestBody<'/v1/my-jobs/{jobSlug}/suspend', 'post'>;
interface UseSwrSuspendJobProps {
  locale?: Locale;
  jobSlug: string;
  onSuccess?: () => void;
}

/**
 * @description Hook for suspending a job. On success, it will show a toast.
 * - `locale`: The current app locale.
 * - `jobSlug`: The job slug.
 * - `onSuccess`: Optional callback to execute on success.
 */
export const useSwrSuspendJob = (props: UseSwrSuspendJobProps) => {
  const { locale, jobSlug, onSuccess } = props;
  const { t } = useTranslation('common');

  // SWR, activate the job
  return useSwrMutationApi<undefined, UseSwrSuspendJobReqBody>({
    url: `/v1/my-jobs/${jobSlug}/suspend`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess,
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText: t('my-jobs.toast.suspend'),
      showErrorToast: true,
    },
  });
};
